import React from 'react'
import PropTypes from 'prop-types'
import Row from '../../../bootstrap/component/Row'
import Column from '../../../bootstrap/component/Column'
import ContentBox from '../../../layout/component/ContentBox'
import { formatDateTime } from '../../../../util/datetime'
import { renderAppointmentStatus } from '../../util/names'
import { renderStoreNameById } from '../../../store/util/renderStoreName'
import { Link } from 'react-router-dom'
import currentUserHasAccess from '../../../../util/widget-helper'
import { APPOINTMENT_LIST_WIDGET_CONTAINER } from '../../../process/ui-definition/process-ui'


const AppointmentList = ({ appointmentList }) => {
    if (!currentUserHasAccess(APPOINTMENT_LIST_WIDGET_CONTAINER)) {
        return null
    }

    return (
        <ContentBox title="Appointment List">

            <Row>
                <Column size={12}>
                    <table className="default-table">
                        <thead>
                            <tr>
                                <th>Created</th>
                                <th>Store</th>
                                <th>Start Time</th>
                                <th>End Time</th>
                                <th>Status</th>
                                <th>Appointment Type</th>
                                <th>Cancel Category</th>
                                <th>View</th>
                            </tr>
                        </thead>
                        <tbody>
                            {appointmentList.map(appointment => {
                                return <tr key={appointment.id}>
                                    <td>{formatDateTime(appointment.created)}</td>
                                    <td>{renderStoreNameById(appointment.storeId)}</td>
                                    <td>{formatDateTime(appointment.startTime)}</td>
                                    <td>{formatDateTime(appointment.endTime)}</td>
                                    <td>{renderAppointmentStatus(appointment.status)}</td>
                                    <td>{appointment.appointmentType}</td>
                                    <td>{appointment.cancelCategory}</td>
                                    <td><Link to={'/appointment/edit/' + appointment.id}>View</Link></td>
                                </tr>
                            })}
                        </tbody>
                    </table>
                </Column>
            </Row>
        </ContentBox>
    )
}

AppointmentList.propTypes = {
    appointmentList: PropTypes.array.isRequired,
}

export default AppointmentList




// WEBPACK FOOTER //
// ./src/modules/appointment/component/list/AppointmentList.js